import React from "react";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/education.css";

const Education = () => {
	return (
		<div className="education">
			<Card
				icon={faGraduationCap}
				title="Education"
				body={
					<div className="home-education-body">
						<div className="home-education-item">
							<div className="home-education-header">
								<div className="home-education-left">
									<img
										src="./utoronto.png"
										alt="University of Toronto"
										className="home-education-image"
									/>
									<div className="home-education-school">University of Toronto</div>
								</div>
								<div className="home-education-duration">Sep 2021 - Dec 2022</div>
							</div>
							<div className="home-education-degree">MSc in Applied Computing</div>
						</div>

						<div className="home-education-item">
							<div className="home-education-header">
								<div className="home-education-left">
									<img
										src="./tsinghua.png"
										alt="Tsinghua University"
										className="home-education-image"
									/>
									<div className="home-education-school">Tsinghua University</div>
								</div>
								<div className="home-education-duration">Sep 2017 - Jun 2021</div>
							</div>
							<div className="home-education-degree">BEng in Automation</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Education;